import { View } from 'src/ui/basic/View'
import {
    horizontalChildSpacing,
    verticalChildSpacing
} from 'src/ui/style/mixins/layout'
import { ContactLink } from 'src/routing/ui/ContactLink'
import { socialMediaLinks } from 'src/business/contact/contactInfo'
import { css } from 'src/ui/style/css'
import { icon } from 'src/ui/icon/icons'
import React, { ComponentType } from 'react'
import { useTheme } from 'src/ui/style/useTheme'
import { ExternalLink } from 'src/routing/ui/ExternalLink'
import { transparentize } from 'polished'
import { Icon } from 'src/ui/icon/Icon'
import { FooterColumn } from 'src/layout/footer/FooterColumn'
import { IconType } from 'react-icons'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'
import { getAppContext } from '../../context/AppContext'
import { NoClickButton } from '../../ui/basic/Button'
import { whatsAppLink } from '../whatsAppLink'
import { Text } from '../../ui/basic/Text'
import { titleStyle } from './AppCardColumn'
import { textStyle } from '../../business/landing-page/style/mixins'

const SocialIcon: ComponentType<{ link: string; icon: IconType }> = ({
    link,
    icon
}) => {
    const th = useTheme()
    return (
        <ExternalLink
            value={link}
            css={css`
                border-radius: 50%;
                background: ${transparentize(0.3, th.colors.white)};
                display: flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 30px;
            `}
        >
            <Icon
                icon={icon}
                css={css`
                    color: ${th.colors.tertiary};
                `}
            />
        </ExternalLink>
    )
}

export const ContactColumn = () => {
    const th = useTheme()
    const t = useTran()
    const contactTel = getAppContext()?.config?.contactTel
    const contactEmail = getAppContext()?.config.contactEmail
    return (
        <FooterColumn title={t(msg.ui.footer.contactColumn.title)}>
            <View css={verticalChildSpacing(th.spacing.sm)}>
                <ContactLink value={contactEmail} type="email">
                    {contactEmail}
                </ContactLink>
                <ContactLink value={contactTel} type="tel">
                    {contactTel}
                </ContactLink>
            </View>
            <View
                horizontal
                css={[
                    horizontalChildSpacing(th.spacing.sm),
                    css`
                        justify-content: flex-start;
                        margin-bottom: 2rem !important;
                    `
                ]}
            >
                <SocialIcon
                    link={socialMediaLinks.facebook}
                    icon={icon.Facebook}
                />
                <SocialIcon
                    link={socialMediaLinks.instagram}
                    icon={icon.Instagram}
                />
                <SocialIcon
                    link={socialMediaLinks.youtube}
                    icon={icon.Youtube}
                />
                <SocialIcon
                    link={socialMediaLinks.linkedin}
                    icon={icon.Linkedin}
                />
            </View>
            <View css={verticalChildSpacing(th.spacing.sm)}>
                <Text css={titleStyle()}>
                    {t(msg.ui.footer.contactColumn.openHours.title)}
                </Text>
                <Text css={textStyle()}>
                    {t(msg.ui.footer.contactColumn.openHours.text)}
                </Text>
            </View>
        </FooterColumn>
    )
}
